'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options"];
import { useContext } from 'react';
import FormattedHTMLMessageBase from 'I18n/components/FormattedHTMLMessage';
import FormattedMessageBase from 'I18n/components/FormattedMessage';
import { LocaleContext } from './LocaleProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const createI18nComponentWithLocaleContext = Component => _ref => {
  let {
      options = {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    locale
  } = useContext(LocaleContext);
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    options: Object.assign({}, options, {
      locale
    })
  }));
};
export const FormattedMessage = createI18nComponentWithLocaleContext(FormattedMessageBase);
export const FormattedHTMLMessage = createI18nComponentWithLocaleContext(FormattedHTMLMessageBase);